var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"fill-height ma-0",attrs:{"align":"center","justify":"center"}},[_c('v-progress-circular',{attrs:{"aria-label":"cargando imagen","indeterminate":"","color":_vm.circulo,"size":_vm.circuloAltura}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }